import { Component, OnInit, ViewChild } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { Dropdown } from 'primeng/dropdown';

@Component({
  selector: 'app-ag-primedropdown-editor',
  template: `
    <p-dropdown 
      #primeDropdown
      [options]="dropdownValues"
      [(ngModel)]="selectedValue"
      name="selectedValue"
      (onChange)="onSelectionChange($event)"
      [style]="{'width': dropdownWidth}"
      [styleClass]="'ag-grid-dropdown-custom drop-down group-details-inp drop-admin'"
      [ngClass]="{'ag-grid-dropdown-custom-open': isDropdownOpen}"
      (onShow)="isDropdownOpen = true"
      (onHide)="isDropdownOpen = false"
      [panelStyle]="{'max-height': '300px', 'overflow': 'auto','width': dropdownWidth}" >
    </p-dropdown>
  `,
  styleUrls: ['../group-admin/group-admin.component.scss'],
})
export class AgPrimedropdownEditorComponent implements ICellEditorAngularComp, OnInit {
  @ViewChild('primeDropdown') primeDropdown!: Dropdown;

  public dropdownValues: any[] = [];
  public selectedValue: any;
  public dropdownWidth: string = '200px';
  isDropdownOpen = false;

  agInit(params: any): void {
    this.dropdownValues = params.values.map((value) => ({
      label: value,
      value,
    }));
    this.selectedValue = params.value;
    if (params.column.actualWidth) {
      this.dropdownWidth = `${Math.max(150, params.column.actualWidth)}px`;
    }
    document.documentElement.style.setProperty('--dropdown-width', this.dropdownWidth);
  }

  getValue(): any {
    return this.selectedValue;
  }

  isPopup(): boolean {
    return true;
  }

  onSelectionChange(event: any) {
    this.selectedValue = event.value;
  }

  ngOnInit() {}

  // This is the key: Open dropdown after attached
  afterGuiAttached(): void {
    setTimeout(() => {
      if (this.primeDropdown) {
        this.primeDropdown.show();
      }
    });
  }
}
